export const onClientEntry = () => {
    // Suppress various React warnings
    const originalWarn = console.warn;
    const originalError = console.error;
    
    console.warn = (...args) => {
        const message = args[0]?.toString() || '';
        if (
            message.includes('defaultProps will be removed from function components') ||
            message.includes('ToastContainer: Support for defaultProps will be removed') ||
            message.includes('ReactDOM.hydrate is no longer supported in React 18') ||
            message.includes('Expected server HTML to contain a matching') ||
            message.includes('Warning: Each child in a list should have a unique "key" prop') ||
            message.includes('validateDOMNesting') ||
            message.includes('<a> cannot appear as a descendant of <a>') ||
            message.includes('Swiper Loop Warning') ||
            message.includes('The number of slides is not enough for loop mode') ||
            message.includes('was preloaded using link preload but not used') ||
            message.includes('preloaded using link preload') ||
            message.includes('Please make sure it has an appropriate') ||
            message.includes('Ignoring Event: localhost') ||
            message.includes('The resource') && message.includes('was preloaded') ||
            message.includes('within a few seconds from the window') ||
            message.includes('intentionally')
        ) {
            return;
        }
        originalWarn.apply(console, args);
    };
    
    console.error = (...args) => {
        const message = args[0]?.toString() || '';
        if (
            message.includes('ReactDOM.hydrate is no longer supported in React 18') ||
            message.includes('Expected server HTML to contain a matching')
        ) {
            return;
        }
        originalError.apply(console, args);
    };

    window.onload = () => {
        if (window.MSInputMethodContext && document.documentMode) {
            var script = document.createElement('script');
            script.onload = () => {
                cssVars();
            };
            script.src = 'https://cdn.jsdelivr.net/npm/css-vars-ponyfill@2';
            document.getElementsByTagName('head')[0].appendChild(script);

            return () => {
                document.head.removeChild(script);
                document.head.removeChild(polyfillScript);
            };
        }
    };
};

// fix jump to anchor load
export const onRouteUpdate = route => {
        setTimeout(() => {
            let el = null;

            if (document.location.hash) {
                el = document.querySelector(`${document.location.hash}`);
            }

            if (el) {
                el.scrollIntoView();
            }
        }, 800);
}
